import styled from 'styled-components'
import { Button } from 'antd'
import type { ReactNode } from 'react'
import WizrFlexLayout from '../../WizrFlexLayout'
import WizrText from '../../WizrText'

export const ToolFormCard = styled(WizrFlexLayout)`
  position: relative;
  background: #fff;
  text-align: left;
  border-radius: 16px;
  padding: 16px;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  min-height: 200px;
`

export const IndividualSettingsBox = styled.div`
  width: 100%;
  text-align: left;
  height: auto;
  background-color: white;
  padding: 0;
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  width: 100%;
`

export const FormTwoColRow = styled(WizrFlexLayout)`
  flex: 0 0 auto !important;
  flex-direction: row !important;
  justify-content: flex-start !important;
  align-items: flex-start !important;
  align-content: flex-start !important;
  gap: 16px;
  width: 100%;
  background: transparent !important;
  overflow: visible !important;
`

export const FormHalfColumn = styled(WizrFlexLayout)`
  flex: 1;
  min-width: 0;
  flex-direction: column !important;
  background: transparent !important;
  align-items: stretch !important;
  justify-content: flex-start !important;
  overflow: visible !important;
`

export const InputParamsContainer = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 16px 0 0;
  gap: 16px;
  box-sizing: border-box;
`

export const LlmParamField = styled.div`
  flex: 1;
  min-width: 0;

  .ant-input-affix-wrapper {
    border: none !important;
    box-shadow: none !important;
    background: #f2f4f9 !important;
    border-radius: 12px !important;
    min-height: 48px !important;
    padding-inline: 14px !important;
  }

  .ant-input-affix-wrapper .ant-input {
    background: transparent !important;
  }

  .ant-input-affix-wrapper:hover,
  .ant-input-affix-wrapper-focused {
    border: none !important;
    box-shadow: none !important;
  }

  input.ant-input {
    border: none !important;
    box-shadow: none !important;
    background: #f2f4f9 !important;
    border-radius: 12px !important;
    height: 48px !important;
    font-weight: 500 !important;
  }

  input.ant-input:hover,
  input.ant-input:focus {
    border: none !important;
    box-shadow: none !important;
  }
`

export const LlmParamRow = styled(WizrFlexLayout)`
  align-items: center;
  gap: 12px;
  width: 100%;
`

export const LlmAddParameterButton = styled(Button)`
  width: 100% !important;
  background: #f2f4f9 !important;
  border: 1px solid #e8eaed !important;
  border-radius: 12px !important;
  color: #1d1f22 !important;
  height: 44px !important;
  font-weight: 500 !important;
  margin-top: 0 !important;
  align-self: stretch !important;

  &:hover {
    background: #e8ecf2 !important;
    border-color: #dde1e8 !important;
    color: #1d1f22 !important;
  }
`

export const RemoveParamButton = styled(Button)`
  flex-shrink: 0;
  color: #999b9f !important;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 0 !important;

  &:hover {
    color: #1d1f22 !important;
    background: transparent !important;
  }
`

export const FieldCell = ({
  label,
  children,
  fieldKey,
}: {
  label: string
  children: ReactNode
  fieldKey?: string
}) => (
  <IndividualSettingsBox
    style={{ padding: '0px' }}
    {...(fieldKey ? { 'data-validation-field': fieldKey } : {})}
  >
    <InputContainer>
      <WizrText type='body2'>{label}</WizrText>
      {children}
    </InputContainer>
  </IndividualSettingsBox>
)

export const TwoColRow = ({
  left,
  right,
}: {
  left: ReactNode
  right?: ReactNode | null
}) => (
  <FormTwoColRow>
    <FormHalfColumn>{left}</FormHalfColumn>
    {right != null && <FormHalfColumn>{right}</FormHalfColumn>}
  </FormTwoColRow>
)
